<script lang="ts">
	import {
		add_to_kroger_cart,
		get_user_settings,
		logout_kroger,
	} from "../tastummy";
	import { kroger_client_id, kroger_redirect_uri } from "../tastummy_login";
	let settings_promise = get_user_settings();

	function activate_kroger_features() {
		// forward to kroger oauth page
		window.location.href = `https://api.kroger.com/v1/connect/oauth2/authorize?response_type=code&client_id=${kroger_client_id}&redirect_uri=${kroger_redirect_uri}&scope=product.compact cart.basic:write&`;
	}
	function deactivate_kroger_features() {
		let res = logout_kroger();
		console.log(res);
	}

	function add_eggs() {
		let res = add_to_kroger_cart();
		console.log(res);
	}
</script>

<div>
	{#await settings_promise then settings}
		<div>Kroger Integration:</div>
		{#if settings.data.kroger_activated}
			<div>Active</div>
			<button on:click={add_eggs}>add eggs</button>
			<button class="delete" on:click={deactivate_kroger_features}
				>Deactivate</button
			>
		{:else}
			<button on:click={activate_kroger_features}>Activate</button>
		{/if}
	{:catch e}
		<div>Error loading settings</div>
	{/await}
</div>
